import { appPages } from "../../../context/pages.config";
import AsideFooterPart from "../../../templates/layouts/_parts/AsideFooter.part";
import AsideHeadPart from "../../../templates/layouts/_parts/AsideHead.part";
import Aside, { AsideBody } from "./Aside/Aside";
import { NavItem, NavSeparator } from "./Navigation/Nav";

const AdminLayouts = () => {
  return (
    <>
      <Aside>
        <AsideHeadPart />
        <AsideBody>
          <NavItem {...appPages.salesAppPages.subPages.salesDashboardPage} />
          <NavItem {...appPages.salesAppPages.subPages.user} />
          <NavItem {...appPages.salesAppPages.subPages.locations} />
          <NavItem {...appPages.salesAppPages.subPages.equipments} />
          <NavItem {...appPages.salesAppPages.subPages.myAccount} />
          <NavItem {...appPages.salesAppPages.subPages.watchList} />
          <NavSeparator />
          <NavItem {...appPages.salesAppPages.subPages.adminTools} />
        </AsideBody>
        <AsideFooterPart />
      </Aside>
    </>
  );
};
export default AdminLayouts;
